import "./index.css";
import "react-toastify/dist/ReactToastify.css";
import { PostHogProvider } from "@posthog/react";
import * as Sentry from "@sentry/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { NuqsAdapter } from "nuqs/adapters/tanstack-router";
// import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ToastContainer } from "react-toastify";
import { ErrorFallback } from "./components/ErrorFallback";
import { ThemeProvider } from "./components/theme-provider";
import { authService } from "./lib/auth-service";
import { initPostHog, posthog } from "./lib/posthog";
import { initSentry } from "./lib/sentry";
import { RTVIProvider } from "./providers/RTVIProvider";
import { routeTree } from "./routeTree.gen";

// PostHog must initialize before Sentry so posthog.sentryIntegration() works
initPostHog();
initSentry();

const queryClient = new QueryClient();
export const router = createRouter({
	routeTree,
	basepath: import.meta.env.BASE_URL,
	context: {
		queryClient,
		auth: {
			isAuthenticated: () => authService.isAuthenticated(),
			getAuthToken: () => authService.getAuthToken(),
			ensureValidToken: () => authService.ensureValidToken(),
		},
	},
});

declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
}

// biome-ignore lint/style/noNonNullAssertion: intentional
createRoot(document.getElementById("root")!).render(
	// <StrictMode>
	<Sentry.ErrorBoundary fallback={<ErrorFallback />}>
		<NuqsAdapter>
			<QueryClientProvider client={queryClient}>
				<ThemeProvider storageKey="amp-theme">
					<RTVIProvider>
						<PostHogProvider client={posthog}>
							<RouterProvider router={router} />
						</PostHogProvider>
						<ToastContainer
							position="top-right"
							autoClose={5000}
							hideProgressBar={false}
							newestOnTop={false}
							closeOnClick
							rtl={false}
							pauseOnFocusLoss
							draggable
							pauseOnHover
							theme="light"
						/>
					</RTVIProvider>
				</ThemeProvider>
				{/* <ReactQueryDevtools initialIsOpen={false} /> */}
			</QueryClientProvider>
		</NuqsAdapter>
	</Sentry.ErrorBoundary>,
	// </StrictMode>,
);
